import { Dispatch, SetStateAction, useCallback, useState } from "react";

const useToggle: (
  initialState?: boolean
) => [boolean, () => void, Dispatch<SetStateAction<boolean>>] = (
  initialState
) => {
  const [value, setValue] = useState(initialState ?? false);
  const toggleValue = useCallback(() => setValue((pv) => !pv), []);

  return [value, toggleValue, setValue];
};

export default useToggle;
